import { useCallback, useEffect, useState } from 'react';
import Axios from 'axios';
import * as Routes from '@/modules/routes';

export interface LinkedProgram {
  class_par_exists: boolean;
  id: number;
  name: string;
}

interface LinkedProgramsResponse {
  data: LinkedProgram[];
}

interface UseLinkedProgramsResult {
  error: string | null;
  isLoading: boolean;
  programs: LinkedProgram[];
  refetch: () => void;
}

const useLinkedPrograms = (classroomId: number): UseLinkedProgramsResult => {
  const [programs, setPrograms] = useState<LinkedProgram[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [refetchCounter, setRefetchCounter] = useState(0);

  const refetch = useCallback(() => setRefetchCounter(c => c + 1), []);

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    Axios.get<LinkedProgramsResponse>(Routes.plato_api_linked_programs_classroom_path(classroomId))
      .then(response => setPrograms(response.data.data))
      .catch(() => setError('Failed to load linked programs'))
      .finally(() => setIsLoading(false));
  }, [classroomId, refetchCounter]);

  return { error, isLoading, programs, refetch };
};

export default useLinkedPrograms;
